import { EDatasourceType } from "@kuika/kuika-cl-model";
import { KuikaSelectboxOption } from "../../ui-kit/kuika-selectbox/kuika-selectbox";

/**
 * What a C# action can be: a plain function, or one of the providers the platform calls at a
 * known point in a request. Two pickers offer the same list — the create dialog and the
 * editor's own header — so the names live in one place rather than drifting apart. Only the
 * header ever adds to it, see getCSharpTemplateOptionsFor.
 */
export const CSHARP_TEMPLATE_OPTIONS: KuikaSelectboxOption[] = [
  {
    value: EDatasourceType.CSharpFunctions,
    label: "Default C# Function",
    testId: "csharpTemplateOption-CSharpFunctions"
  },
  {
    value: EDatasourceType.CustomAuthenticationProvider,
    label: "Custom Authentication Provider",
    testId: "csharpTemplateOption-CustomAuthenticationProvider"
  },
  {
    value: EDatasourceType.CustomAuthorizationProvider,
    label: "Custom Authorization Provider",
    testId: "csharpTemplateOption-CustomAuthorizationProvider"
  },
  {
    value: EDatasourceType.CustomVerificationCodeSenderProvider,
    label: "Custom Verification Code Sender Provider",
    testId: "csharpTemplateOption-CustomVerificationCodeSenderProvider"
  },
  {
    value: EDatasourceType.CustomExternalTokenValidatorProvider,
    label: "Custom External Token Validator Provider",
    testId: "csharpTemplateOption-CustomExternalTokenValidatorProvider"
  },
  {
    value: EDatasourceType.CustomMailProvider,
    label: "Custom Mail Provider",
    testId: "csharpTemplateOption-CustomMailProvider"
  }
];

/**
 * The Custom Connection String Provider is retired — nothing new can become one — yet older
 * datasources still carry the type. Their editor header still names it, disabled.
 */
const RETIRED_CONNECTION_STRING_PROVIDER_OPTION: KuikaSelectboxOption = {
  value: EDatasourceType.CustomConnectionStringProvider,
  label: "Custom Connection String Provider",
  testId: "csharpTemplateOption-CustomConnectionStringProvider",
  disabled: true
};

/** The editor header's list for an open datasource of the given type. */
export const getCSharpTemplateOptionsFor = (datasourceType: EDatasourceType | undefined): KuikaSelectboxOption[] => {
  if (datasourceType === EDatasourceType.CustomConnectionStringProvider) {
    return [...CSHARP_TEMPLATE_OPTIONS, RETIRED_CONNECTION_STRING_PROVIDER_OPTION];
  }
  return CSHARP_TEMPLATE_OPTIONS;
};

/** The provider templates that need their own subscription asset; picking one without it is refused. */
export const GATED_CSHARP_TEMPLATES: EDatasourceType[] = [
  EDatasourceType.CustomAuthenticationProvider,
  EDatasourceType.CustomAuthorizationProvider,
  EDatasourceType.CustomVerificationCodeSenderProvider,
  EDatasourceType.CustomExternalTokenValidatorProvider
];

/** The domain access that unlocks the gated templates. */
export const GATED_CSHARP_TEMPLATE_ACCESS: string = "Custom SSO";
